export default function (store, column) {
    if (store.field == column) {
        if (store.direction == 'asc') {
            return 'sorting--asc';
        }

        return 'sorting--desc';
    }
}


// WEBPACK FOOTER //
// ./src/utils/order.js